import { token } from '@atlaskit/tokens';

export const overrideMarks: string[] = ['backgroundColor'];

export const DEFAULT_COLOR = {
	color: token('color.text'),
	label: 'Default',
};
